<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="Object.keys(errors).length">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors.ReputationProvider" :key="key">
                    {{key}}: {{error[0]}}
                </p>
            </div>
        </div>
        <br/>

        <div class="form-group">
            <label for="provider_name" class="mb-1">Name:</label>
            <input v-model="provider.name" type="text" class="form-control" id="provider_name" :disabled=true>
        </div>
        <div class="form-group">
            <label class="custom-control custom-checkbox m-b-0">
                <input v-model="provider.affectsRelayStatus" type="checkbox" class="custom-control-input">
                <span class="custom-control-label">Affects the relay status</span>
            </label>
        </div>
        <div class="form-group">
            <label class="custom-control custom-checkbox m-b-0">
                <input v-model="provider.active" type="checkbox" class="custom-control-input">
                <span class="custom-control-label">Is Active</span>
            </label>
        </div>
        <br>
        <div class="form-group text-center p-b-20 p-t-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light">
                    Save
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import Breadcrumb from '../../components/Breadcrumb';
    import ReputationProviderService from '../../services/ReputationProviderService';
    import Preloader from '../../components/Preloader';

    export default {
        name: 'ReputationProviderForm',
        props: ['id'],
        components: {Breadcrumb, Preloader},
        data() {
            return {
                provider: {
                    name: null,
                    affectsRelayStatus: true,
                    active: true,
                },
                errors: {},
            }
        },
        mounted() {
            ReputationProviderService.getProvider(this.id).then(response => {
                    this.provider = response.data;
                    this.$emit('hidePreloader', true)
                });
        },
        methods: {
            onSubmit() {
                this.$emit('hidePreloader', false);

                ReputationProviderService.updateProvider(this.id, JSON.stringify(this.provider)).then(response => {
                    if (response.data.error !== undefined) {
                        this.errors = response.data.error;
                        this.$emit('hidePreloader', true);
                    } else {
                        this.$router.push({name: 'ReputationProviderList'});
                    }
                });
            }
        }
    }
</script>